module.exports = __webpack_public_path__ + "img/img_tab_pc.730071cd.svg";